var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticStyle:{"transition":"all 0.2s"},style:({
    'padding-left': _vm.navigationmode === 'fixed' ? _vm.paddingLeft + 'px' : 0
  })},[(_vm.navigationmode === 'fixed')?_c('div',{style:({ height: _vm.headerHeight + 'px' })}):_vm._e(),_c('Header',{ref:"header"}),_c('a-layout-content',{staticClass:"LayoutMain",style:({
      margin: '20px 20px 0',
      paddingBottom: '20px',
      minHeight: `calc(100vh - ${_vm.headerHeight + 40}px)`,
      minWidth: 0
    })},[_c('div',{staticClass:"LayoutMain-inner",style:({
        minHeight: `calc(100vh - ${_vm.headerHeight + 60}px)`
      })},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }